// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"quoted_blockquote__Sjetc"};